import { forwardRef } from 'react';
import type { ElementType } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import type { Theme, SxProps } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  disabledLink?: boolean;
  size?: number | string;
  sx?: SxProps<Theme>;
};

const Logo = forwardRef<HTMLAnchorElement, Props>(({ disabledLink = false, size = 40, sx, ...other }, ref) => {
  const logo = (
    <Box component="img" src="/assets/icons/logo.png" sx={{ width: size, height: size, cursor: 'pointer', ...sx }} />
  );

  if (disabledLink) return logo;
  return (
    <Link component={RouterLink as ElementType} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

export default Logo;
